import { call, put, takeLatest, select } from 'redux-saga/effects';
import * as types from './CommunicationActionType';
import * as actions from './CommunicationActions';
import * as communicationService from './CommunicationServices';
import { getLocalDateTime } from '../../../utils/dateUtils';

export function* fettchCommunicationsSaga(action) {
    try {
        const response = yield call(communicationService.getCommunications, action.payload);
        yield put(actions.getCommunicationSuccess(response?.data || {}));
    } catch (error) {
        yield put(actions.getCommunicationFailure(error));
    }
}

export function* fetchNotificationsSaga(action) {
    try {
        const response = yield call(communicationService.getNotifications, action.payload);
        yield put(actions.getNotificationsSuccess(response?.data || {}));
    } catch (error) {
        yield put(actions.getNotificationsFailure(error));
    }
}

export function* fetchCommunicationNotificationSaga(action) {
    try {
        const response = yield call(communicationService.getCommunicationNotification, action.payload);

        // Handle different response formats
        let apiData = null;
        let isSuccess = false;

        if (response?.status === true && response?.data) {
            // Direct response format: { status: true, data: [...] }
            apiData = response.data;
            isSuccess = true;
        } else if (response?.data?.status === true && response?.data?.data) {
            // Nested response format: { data: { status: true, data: [...] } }
            apiData = response.data.data;
            isSuccess = true;
        }

        if (isSuccess && apiData) {
            yield put(actions.getCommunicationNotificationSuccess(apiData));
        } else {
            const errorMsg = response?.data?.responseMessage || response?.responseMessage || 'Failed to fetch communication notifications';
            yield put(actions.getCommunicationNotificationFailure(errorMsg));
        }
    } catch (error) {
        yield put(actions.getCommunicationNotificationFailure(error?.message || 'Network error'));
    }
}

export function* fetchAllOtherCommunicationsSaga(action) {
    try {
        // post() already unwraps to the response body, so `response` here IS
        // { status, responseMessage, data } — not an axios response to unwrap again.
        // On "no records" the body's own data is null; DocumentSection expects an array
        // to .flatMap over, so `response?.data || {}` was handing it a plain object on
        // that path (only), which throws inside its render right after navigating in —
        // exactly why this only showed up with a genuinely empty result.
        const response = yield call(communicationService.getAllOtherCommunications, action.payload);
        yield put(actions.getAllOtherCommunicationsSuccess(response?.data || []));
    } catch (error) {
        yield put(actions.getAllOtherCommunicationsFailure(error));
    }
}

function* logNotificationViewedSaga(action) {
    try {
        const { notificationID } = action.payload;

        // 1️⃣ Save log
        yield call(communicationService.saveNotificationViewLog, {
            notificationID
        });

        // 2️⃣ Refresh notifications
        const userId = yield select(
            state => state.auth.userData.userId
        );

        yield put(
            actions.getCommunicationNotificationRequest({ 
                ModifiedBy: userId,
                CurrentDateTime: getLocalDateTime()
            })
        );

    } catch (error) {
        console.error("Notification view log error:", error);
    }
}


export default function* watchCommunicationSaga() {
    yield takeLatest(types.GET_COMMUNICATIONS_REQUEST, fettchCommunicationsSaga);
    yield takeLatest(types.GET_NOTIFICATIONS_REQUEST, fetchNotificationsSaga);
    yield takeLatest(types.GET_COMMUNICATION_NOTIFICATION_REQUEST, fetchCommunicationNotificationSaga);
    yield takeLatest(types.GET_ALL_OTHER_COMMUNICATIONS_REQUEST, fetchAllOtherCommunicationsSaga);
    yield takeLatest(types.LOG_NOTIFICATION_VIEW_REQUEST,logNotificationViewedSaga);
}